import { docxClient } from "../clients/docx.client";
import type { ReportDocumentProps } from "../../hooks/useReportPDF";
import { REPORT_CONSTANTS } from "../../config/constants";
import { extractCombinedData } from "../../helpers";
import { parseFilenameFromContentDisposition } from "~/helpers/parse-content-disposition.helper";

export interface GeneratedDocument {
  url: string;
  filename?: string;
}

class DOCXGateway {
  async generateDOCX(props: ReportDocumentProps): Promise<GeneratedDocument> {
    try {
      const reportType = props.metadata?.[REPORT_CONSTANTS.new_report.report_type];
      const isCombinado = reportType === REPORT_CONSTANTS.types.combinado;
      const docxPayload = isCombinado ? extractCombinedData(props) : props; // Caso seja combinado, filtrar para enviar apenas combined_data

      const response = await docxClient.post('/create/docx', docxPayload, {
        responseType: 'blob'
      });

      const docxBlob = response.data;
      const url = URL.createObjectURL(docxBlob);
      const filename = parseFilenameFromContentDisposition(
        response.headers?.['content-disposition'] ?? response.headers?.['Content-Disposition'],
      );

      console.log('DOCX generated successfully by service');
      return { url, filename };
    } catch (error) {
      console.error('Error calling DOCX service:', error);
      throw error;
    }
  }
}

export const docxGateway = new DOCXGateway();